<template>
  <div>
    <el-dialog
      title="在玩人数区间编辑"
      :visible.sync="dialogData.show"
      center
      width="800px"
    >
      <el-form
        :model="formData"
        label-width="180px"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="$t('minimumOnlinePlayers')" prop="OnlineMin">
          <el-input
            type="number"
            v-model="formData.OnlineMin"
            @input="OnHandleMinInput"
           :placeholder="$t('enterMinimumOnlinePlayers')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="最高在线人数：" prop="OnlineMax">
          <el-input
            type="number"
            v-model="formData.OnlineMax"
            @input="OnHandleMaxInput"
            placeholder="请输入最高在线人数"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item  :label="$t('GoogleVerificationCode')" prop="GoogleCode">
          <el-input v-model="formData.GoogleCode" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogData.show = false">{{$t('Cancel')}}</el-button>
        <el-button type="primary" @click="submitForm()">{{$t('Confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import base from "@/api/base.js";
import { app } from "@/api/app.js";
export default {
  extends: base,
  props: {
    dialogData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    dialogchannel() {
      let channelList = JSON.parse(localStorage.getItem("channel")) || [];
      let arr = [];
      if (this.formData.SellerId) {
        arr = channelList.filter(
          (item) => item.SellerId == this.formData.SellerId
        );
      } else {
        arr = channelList;
      }
      return arr;
    },
  },
  data() {
    const validate1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入数据统计周期"));
      } else if (value < 15 || value > 60) {
        callback(new Error("范围限制输入15-60分钟"));
      } else {
        callback();
      }
    };
    const validate2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t('enterMinimumOnlinePlayers')));
      } else if (value < 5 || value > 20) {
        callback(new Error("范围限制输入5-20条"));
      } else {
        callback();
      }
    };
    return {
      formData: {
        SellerId: "",
        OnlineMin: "",
        OnlineMax: "",
        GoogleCode: "",
      },
      rules: {
        SellerId: [
          { required: true, message: this.$t('SelectOperatorAgain'), trigger: "change" },
        ],
        ChannelId: [
          { required: true, message: "请选择运渠道", trigger: "change" },
        ],
        GameType: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        IntervalTime: [
          // { required: true, validator: validate1, trigger: "blur" },
          { required: true, message: "请输入数据统计周期", trigger: "blur" },
        ],
        DisplayRows: [
          { required: true, validator: validate2, trigger: "blur" },
        ],
        MinRewardAmount: [
          { required: true, message: this.$t('enterMinimumProfitAmount'), trigger: "blur" },
        ],
        MinOnlineUsers: [
          { required: true, message: this.$t('enterMinimumOnlinePlayers'), trigger: "blur" },
        ],
        GoogleCode: [
          { required: true, message: this.$t('EnterGoogleVerificationCode'), trigger: "blur" },
        ],
      },
      gameTypeList: [],
      typeValueList: [],
    };
  },

  created() {
    this.formData.OnlineMin = this.dialogData.row.OnlineMin;
    this.formData.OnlineMax = this.dialogData.row.OnlineMax;
    this.app = app;
  },
  methods: {
    OnChangeInt(pValue) {
      if (pValue === "") {
        return "";
      }
      pValue = Math.abs(pValue);
      return Math.floor(pValue);
    },
    OnHandleMaxInput() {
      this.formData.OnlineMax = this.OnChangeInt(this.formData.OnlineMax);
    },
    OnHandleMinInput() {
      this.formData.OnlineMin = this.OnChangeInt(this.formData.OnlineMin);
    },
    submitForm(formName) {
      if (this.formData.OnlineMin === "") {
        this.$message.error(this.$t('enterMinimumOnlinePlayers'));
        return;
      }
      if (this.formData.OnlineMax === "") {
        this.$message.error("请输入最高在线人数");
        return;
      }
      if (Number(this.formData.OnlineMax) < Number(this.formData.OnlineMin)) {
        this.$message.error("最高在线人数 需大于 最低在线人数，请修改！");
        return;
      }
      const data = {
        Id: this.dialogData.row.Id,
        Type: Number(this.dialogData.type),
        OnlineMin: Number(this.formData.OnlineMin),
        OnlineMax: Number(this.formData.OnlineMax),
        GoogleCode: this.formData.GoogleCode,
      };
      app.post("/game/update_online", data, (res) => {
        if (res.code == 200) {
          this.$message.success(this.$t('EditSuccess'));
          this.dialogData.show = false;
          this.$emit("success");
        }
      });
    },
  },
};
</script>

<style scoped>
.el-checkbox {
  width: 80px;
}
</style>
